<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <collecting-institution-form
      :isLoading="isLoading"
      :onSubmit="onSubmit">
    </collecting-institution-form>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import CollectingInstitutionForm from './CollectingInstitutionForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { collectingInstitutionRegistry } = services;
const { collectingInstitutionService } = collectingInstitutionRegistry;

export default {
  name: 'CollectingInstitutionCreate',
  components: {
    CollectingInstitutionForm,
    LandingCreate,
  },
  data: () => ({
    isLoading: false,
    content: {
      pageTitle: 'Create Collecting Institution',
      enableBackButton: true,
    },
  }),
  methods: {
    async onSubmit(data) {
      console.log('data', data);
      this.isLoading = true;
      try {
        const { _id: id } = await collectingInstitutionService
          .create({ collectingInstitution: data });

        this.$snackbar.showOk({ text: 'Successfully created Collecting Institution!' });

        this.$router.replace({ name: 'collecting-institution.edit', params: { id } });
      } catch (e) {
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
      this.isLoading = false;
    },
  },
};
</script>
